import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import * as helper from './formStore.helper';
import { Form, PrivacyFormStore, ReconsiderationsFormStore } from './formStore.type';

const InitialStatePrivacy = {
  consent_1: false,
  consent_2: false,
  consent_3: false,
};

const InitialStateReconsiderations = {
  no_ripens: false,
};

const formsStatus = {
  contractual: false,
  reconsiderations: false,
  allLinksClicked: false,
};

const formsData = {
  privacy: InitialStatePrivacy,
  reconsiderations: InitialStateReconsiderations,
  links: {} as Record<string, boolean>,
};

const useFormStore = create<Form>()(
  devtools(set => ({
    data: formsData,
    status: formsStatus,
    actions: {
      validateContractualForm: (validate: boolean) =>
        set(store => helper.validateContractualForm(store, validate)),
      validateReconsiderationsForm: (validate: boolean) =>
        set(store => helper.validateReconsiderationsForm(store, validate)),
      setPrivacyFormValues: (values: PrivacyFormStore) =>
        set(store => helper.setPrivacyFormValues(store, values)),
      setReconsiderationsFormValue: (value: ReconsiderationsFormStore) =>
        set(store => helper.setReconsiderationsFormValue(store, value)),
      addLink: (linkId: string) =>
        set(state => ({
          ...state,
          data: { ...state.data, links: { ...state.data.links, [linkId]: false } },
        })),
      validateLink: (linkId: string) =>
        set(state => {
          const updatedLinks = { ...state.data.links, [linkId]: true };
          const allLinksClicked = Object.values(updatedLinks).every(value => value === true);
          return {
            ...state,
            data: { ...state.data, links: updatedLinks },
            status: { ...state.status, allLinksClicked },
          };
        }),
    },
  })),
);

export default useFormStore;
